import React from 'react'
import { Menu } from 'components/Menu'
import ToggleModal from '../ToggleModal'

export class ModalMenu extends React.Component {  
  handleModalRef = (ref) => {
    this.modalRef = ref
  }

  handleMenuClick = (event) => {
    event.stopPropagation()
  }

  renderItem = (item) => {
    return React.cloneElement(item, {
      onClick: (...args) => {
        item.props.onClick && item.props.onClick(...args)

        this.modalRef.close()
      }
    })
  }

  render () {
    const {
      children,
      ...restProps
    } = this.props

    const [firstChild, ...restChildren] = React.Children.toArray(children)

    return (
      <ToggleModal
        {...restProps}
        ref={this.handleModalRef}
      >
        {firstChild}
        <Menu
          hover
          onClick={this.handleMenuClick}
        >
          {React.Children.map(restChildren, this.renderItem)}
        </Menu>
      </ToggleModal>
    )
  }
}

export default ModalMenu

